import React from 'react';
import "../styles.scss";
import ApprovalPageHeaderBg from "../../../../../../assets/img/ApprovalPageHeaderBg.png";

const FinanceApprovalPageHeader = ({
    heading = "Student finance approvals" , 
    subHeading = "Here you can manage your payments related to Cash, Cheque and DD."
}) => {

    return ( 
        <div className='d-flex justify-content-between finance-approval-header'>
            <div>
                <div className="heading">{heading}</div>
                <div>{subHeading}</div>
            </div>
            <img src={ApprovalPageHeaderBg} alt="Approval Page Header" />
        </div>
     );
}
 
export default FinanceApprovalPageHeader;